<template>
  <BorderStyle class="bc500-page-top">
    <div
      class="group"
      :key="`group-${index}`"
      :class="classNames[index]"
      v-for="(columns, index) in config"
    >
      <div class="column" v-for="(column, index) in columns" :key="`column-${index}`">
        <div class="row" v-for="(row, index) in column" :key="`row-${index}`">
          <span class="label">{{ row.label }}:</span>
          <slot
            v-if="row.slot"
            :name="row.slot"
            :row="row"
            :data="data"
            :val="getVal(row, data)"
          ></slot>
          <RowValue v-else :row="row" :data="data" />
        </div>
      </div>
    </div>
  </BorderStyle>
</template>

<script>
import BorderStyle from './border-style.vue';
import { pageTopModel, pageTopGroupClassNames } from '@/utils/deviceDict/bc500';
import RowValue from '@/components/row/row-value.vue';

export default {
  components: { BorderStyle, RowValue },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      config: pageTopModel,
      classNames: pageTopGroupClassNames
    };
  },
  methods: {
    getVal(row, data) {
      const format = row.format;
      let val = null;
      if (Array.isArray(row.prop)) {
        val = row.prop.map(prop => data[prop]);
      } else {
        val = data[row.prop];
      }
      return format ? format(val) : val;
    }
  }
};
</script>

<style lang="scss">
.bc500-page-top {
  display: flex;
  padding: var(--details-padding);
  height: var(--details-height);

  .group {
    display: flex;
    justify-content: space-between;
  }
  .column {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .row {
    font-size: var(--details-font-size);
    padding: var(--details-row-padding);

    .label {
      display: inline-block;
      width: var(--details-label-width);
      text-align: var(--details-label-align);
      color: #2bf2f4;
      margin-right: 10px;
    }
  }

  .group1 {
    width: 39%;
  }
  .group2 {
    width: 39%;
    position: relative;
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 2px;
      height: 100%;
      background: linear-gradient(
        rgba(38, 242, 244, 0.12),
        rgba(38, 242, 244, 1),
        rgba(38, 242, 244, 0.12)
      );
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
  }
  .group3 {
    flex: 1;
  }
}
</style>
